import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import axios from "axios";
import TheHeader from "./components/TheHeader";
import TheFooter from "./components/TheFooter";
import titleMixin from "./mixins/titleMixin";
import infiniteScroll from "vue-infinite-scroll";
import VueTheMask from "vue-the-mask";
import Vuelidate from "vuelidate";

Vue.config.productionTip = false;

Vue.component("TheHeader", TheHeader);
Vue.component("TheFooter", TheFooter);

Vue.mixin(titleMixin);
Vue.use(infiniteScroll);
Vue.use(VueTheMask);
Vue.use(Vuelidate);

// Em desenvolvimento passa pelo proxy do dev server (ver vue.config.js),
// porque a API só responde com CORS liberado para os domínios de produção.
Vue.prototype.$http = axios.create({
  baseURL:
    process.env.NODE_ENV === "production"
      ? "https://api-vendas-todos.azurewebsites.net/api/"
      : "/api-vendas/",
});

Vue.prototype.$api = axios.create({
  baseURL: "https://cartaodetodossport.com.br/api/index.php/wp-json/acf/v3/",
});

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");